<template>
  <div>
    <div class="flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
      <div class="self-center ml-4 text-sm font-semibold text-grey-darkest">Patient History</div>
    </div>

    <!--core main-->
    <div class="flex flex-col overflow-y-auto pb-4 bg-grey-extralight" style="height: calc(100vh - 5rem)">
      <div class="flex flex-col mb-3 py-4 bg-white border-solid border-b border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-row bg-white mx-2">
          <TextField label="Past Medical History" fieldId="past_medical_history" :value="past_medical_history" @saveChange="saveChange"/>
        </div>
        <details class="mx-4 my-2 text-xs mt-2 mb-3 bg-grey-extralight">
          <summary class="flex flex-row p-2 py-3 justify-center cursor-pointer">
            <div class="text-grey-dark font-semibold mr-auto">HRA Info</div>
            <div class="text-grey-dark ml-auto">Updated on: <span class="text-grey-dark font-semibold">{{healthParameterDate}}</span></div>
          </summary>
          <div class="flex flex-col py-1 border-solid border-t border-grey-lighest">
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto font-semibold text-grey-darker">Diabetes</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.diabetic_treatment === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.diabetic_treatment === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto font-semibold text-grey-darker">Cancer</div>
              <div class="flex ml-auto font-semibold text-green">No</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto font-semibold text-grey-darker">BP</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.hypertensive_treatment === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.hypertensive_treatment === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto font-semibold text-grey-darker">Heart Condition</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.cvd_treatment === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.cvd_treatment === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
          </div>
        </details>
      </div>

      <div class="flex flex-col mb-3 py-4 bg-white border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-col px-2">
          <current-medication :chatType="$attrs.chatType" :medication="medication"/>
        </div>
      </div>

      <div class="flex flex-col mb-3 py-4 bg-white border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-row mx-2">
          <TextField label="Surgical History" fieldId="surgical_history" :value="surgical_history" @saveChange="saveChange" />
        </div>
      </div>

      <div class="flex flex-col mb-3 py-4 bg-white border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-row mx-2">
          <TextField label="Known Drug Allergies" fieldId="drug_allergies" :value="drug_allergies" @saveChange="saveChange" />
        </div>
      </div>

      <div class="flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-row mx-2">
          <TextField label="Know Food Allergies" fieldId="food_allergies" :value="food_allergies" @saveChange="saveChange" />
        </div>
      </div>

      <div class="flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-row mx-2">
          <TextField label="Family History" fieldId="family_medical_history" :value="family_medical_history" @saveChange="saveChange" />
        </div>
        <details class="mx-4 my-2 text-xs mt-2 mb-3 bg-grey-extralight">
          <summary class="flex flex-row p-2 py-3 justify-center cursor-pointer">
            <div class="text-grey-dark font-semibold mr-auto">HRA Info</div>
            <div class="text-grey-dark ml-auto">Updated on: <span class="text-grey-dark font-semibold">{{familyHealthParameterDate}}</span></div>
          </summary>
          <div class="flex flex-row border border-solid border-dark rounded-sm">
            <div class="flex flex-col w-64">
              <div class="flex flex-row h-6 justify-center bg-white px-4 py-2 border-solid border-b border-r border-dark">
                <div class="flex mr-auto text-grey-darker self-center">Medical Problem</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark">
                <div class="flex mr-auto text-grey-darker font-semibold">Diabetes</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark">
                <div class="flex mr-auto text-grey-darker font-semibold">BP</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark">
                <div class="flex mr-auto text-grey-darker font-semibold">Heart Condition</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-r border-dark">
                <div class="flex mr-auto text-grey-darker font-semibold">Cancer</div>
              </div>
            </div>
            <div class="flex flex-col w-auto">
              <div class="flex flex-row h-6 justify-center bg-white px-4 py-2 border-solid border-b border-r border-dark">
                <img class="flex mr-auto w-6" src="../../assets/mother.svg">
                <div class="flex pl-2 text-grey-darker self-center">Mother</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark">
                <div class="flex font-semibold text-grey-darker" v-bind:class="getMotherHistory('Diabetes') === 'Yes' ? 'text-red': 'text-green'">{{getMotherHistory('Diabetes')}}</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark">
                <div class="flex font-semibold text-grey-darker" v-bind:class="getMotherHistory('Hypertension') === 'Yes' ? 'text-red': 'text-green'">{{getMotherHistory('Hypertension')}}</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b border-r border-dark">
                <div class="flex font-semibold text-grey-darker" v-bind:class="getMotherHistory('Diabetes') === 'Heart Condition' ? 'text-red': 'text-green'">{{getMotherHistory('Heart Condition')}}</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-r border-dark">
                <div class="flex font-semibold text-grey-darker" v-bind:class="getMotherHistory('Cancer') === 'Yes' ? 'text-red': 'text-green'">{{getMotherHistory('Cancer')}}</div>
              </div>
            </div>
            <div class="flex flex-col w-auto">
              <div class="flex flex-row h-6 justify-center bg-white px-4 py-2 border-solid border-b border-dark">
                <img class="flex mr-auto w-6" src="../../assets/father.svg">
                <div class="flex pl-2 text-grey-darker self-center">Father</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b  border-dark">
                <div class="flex font-semibold text-grey-darker" v-bind:class="getFatherHistory('Diabetes') === 'Yes' ? 'text-red': 'text-green'">{{getFatherHistory('Diabetes')}}</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b  border-dark">
                <div class="flex font-semibold text-grey-darker" v-bind:class="getFatherHistory('Hypertension') === 'Yes' ? 'text-red': 'text-green'">{{getFatherHistory('Hypertension')}}</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2 border-solid border-b  border-dark">
                <div class="flex font-semibold text-grey-darker" v-bind:class="getFatherHistory('Diabetes') === 'Heart Condition' ? 'text-red': 'text-green'">{{getFatherHistory('Heart Condition')}}</div>
              </div>
              <div class="flex flex-row justify-center px-4 py-2">
                <div class="flex font-semibold text-grey-darker" v-bind:class="getFatherHistory('Cancer') === 'Yes' ? 'text-red': 'text-green'">{{getFatherHistory('Cancer')}}</div>
              </div>
            </div>
          </div>
        </details>
      </div>

      <div class="flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-row mx-2">
          <TextField label="Lifestyle History" fieldId="social_history" :value="social_history" @saveChange="saveChange" />
        </div>
        <details class="mx-4 my-2 text-xs mt-2 mb-3 bg-grey-extralight">
          <summary class="flex flex-row p-2 py-3 justify-center cursor-pointer">
            <div class="text-grey-dark font-semibold mr-auto">HRA Info</div>
            <div class="text-grey-dark ml-auto">Updated on: <span class="text-grey-dark font-semibold">{{healthParameterDate}}</span></div>
          </summary>
          <div class="flex flex-col py-1 border-solid border-t border-grey-lighest">
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Low Self Esteem </div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.low_self_esteem === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.low_self_esteem === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Fatigue</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.fatigue === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.fatigue === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Body Aches</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.body_aches === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.body_aches === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Anxiety</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.anxiety === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.anxiety === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Nervous Breakdown</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.nervous_breakdown === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.nervous_breakdown === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Stress Eating</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.stress_eating === 'true'" class="flex ml-auto font-semibold text-red">Yes</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.stress_eating === 'false'" class="flex ml-auto font-semibold text-green">No</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
          </div>
        </details>
      </div>

      <div class="flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-row mx-2">
          <TextField label="Diet Assessment" fieldId="diet_assessment" :value="diet_assessment" @saveChange="saveChange" />
        </div> 
        <details class="mx-4 my-2 text-xs mt-2 mb-3 bg-grey-extralight">
          <summary class="flex flex-row p-2 py-3 justify-center cursor-pointer">
            <div class="text-grey-dark font-semibold mr-auto">HRA Info</div>
            <div class="text-grey-dark ml-auto">Updated on: <span class="text-grey-dark font-semibold">{{healthParameterDate}}</span></div>
          </summary>
          <div class="flex flex-col py-1 border-solid border-t border-grey-lighest">
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Whole Grains</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.whole_grains === '2'" class="flex ml-auto font-semibold text-red">Low</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.whole_grains === '1'" class="flex ml-auto font-semibold text-green">Medium</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.whole_grains === '0'" class="flex ml-auto font-semibold text-green">High</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Fruits and Vegetables</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.fruits_and_vegetables === '2'" class="flex ml-auto font-semibold text-red">Low</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.fruits_and_vegetables === '1'" class="flex ml-auto font-semibold text-yellow">Medium</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.fruits_and_vegetables === '0'" class="flex ml-auto font-semibold text-green">High</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
            <div class="flex flex-row justify-center mx-4 py-2">
              <div class="flex mr-auto text-grey-darker font-semibold">Fried Foods and Refined Carbohydrates</div>
              <div v-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.fried_foods_and_refined_carbohydrates === '2'" class="flex ml-auto font-semibold text-green">Low</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.fried_foods_and_refined_carbohydrates === '1'" class="flex ml-auto font-semibold text-yellow">Medium</div>
              <div v-else-if="customer && customer.details && customer.details.health_parameters && customer.details.health_parameters.fried_foods_and_refined_carbohydrates === '0'" class="flex ml-auto font-semibold text-red">High</div>
              <div v-else class="flex ml-auto font-semibold text-grey-dark">NA</div>
            </div>
          </div>
        </details>
      </div>

      <div v-if="!customer.details.gender || customer.details.gender !== 'Male'" class="flex flex-col bg-white mb-3 py-4 border-solid border-b border-t border-grey-lighest flex-no-shrink flex-no-grow">
        <div class="flex flex-row mx-2">
          <TextField label="Menstrual History" fieldId="menstrual_history" :value="menstrual_history" @saveChange="saveChange" />
        </div> 
        
      </div>

      <!-- <div v-if="customer.details.gender === 'Female'" class="flex flex-row bg-white overflow-y-auto mx-4">
        <TextField label="Regularity of Menstural Cycle" fieldId="menstural_regularity" :value="details.menstural_regularity" @saveChange="saveChange" />
      </div> -->

      <!--footer-->
      <!-- <div class="absolute pin-b flex flex-row bg-white h-12 mt-auto flex-no-shrink flex-no-grow pl-4 border-solid border-t border-grey-light">
        <div class="self-center bg-blue p-2 rounded text-white font-light text-sm px-4">Save</div>
        <div class="self-center bg-blue p-2 rounded text-white font-light ml-2 text-sm px-4">Send to Patient</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import TextField from '@/components/common/TextField'
import CurrentMedication from '@/components/Customer/CurrentMedication'
import {mapGetters} from 'vuex'
import moment from 'moment'
export default {
  components: {
    TextField,
    CurrentMedication
  },
  data () {
    return {
      isEditing: false
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile',
      activeSection: 'configuration/getActiveSection'
    }),
    past_medical_history: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.past_medical_history
      }
    },
    surgical_history: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.surgical_history
      }
    },
    drug_allergies: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.drug_allergies
      }
    },
    food_allergies: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.food_allergies
      }
    },
    family_medical_history: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.family_medical_history
      }
    },
    social_history: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.social_history
      }
    },
    menstrual_history: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.menstrual_history
      }
    },
    diet_assessment: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        return this.customer.details.health_parameters.diet_assessment
      }
    },
    medication: function () {
      if (this.customer && this.customer.details && this.customer.details.medication) {
        return this.customer.details.medication
      }
      return []
    },
    healthParameterDate: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters && this.customer.details.health_parameters.date) {
        return moment(String(this.customer.details.health_parameters.date)).format('DD MMM YYYY')
      }
      return 'NA'
    },
    familyHealthParameterDate: function () {
      if (this.customer && this.customer.details && this.customer.details.family_history && this.customer.details.family_history.date) {
        return moment(String(this.customer.details.family_history.date)).format('DD MMM YYYY')
      }
      return 'NA'
    }
  },
  methods: {
    getMotherHistory: function (parameter) {
      if (this.customer && this.customer.details && this.customer.details.family_history && this.customer.details.family_history.mothers_history && this.customer.details.family_history.mothers_history.includes(parameter)) {
        return 'Yes'
      }
      return 'No'
    },
    getFatherHistory: function (parameter) {
      if (this.customer && this.customer.details && this.customer.details.family_history && this.customer.details.family_history.fathers_history && this.customer.details.family_history.fathers_history.includes(parameter)) {
        return 'Yes'
      }
      return 'No'
    },
    saveChange: function (data) {
      if (this.$attrs.chatType === 'offline') {
        this.saveOfflineConsult(data)
      } else if (this.$attrs.chatType === 'online') {
        this.saveOnlineConsult(data)
      }
    },
    editCurrentMedication: function () {
      this.isEditing = !this.isEditing
    },
    saveOnlineConsult (data) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('consultation/updateHealthParameters', data)
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastConsultation/updateHealthParameters', data)
      }
    },
    saveOfflineConsult (data) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('offlineConsultation/updateHealthParameters', data)
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastOfflineConsultation/updateHealthParameters', data)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Customer/PatientMedicalHistory.vue